import { assertNever } from '@deltasierra/shared';
import moment from 'moment-timezone';
import * as React from 'react';
import { DSTextFieldProps, DSTextField } from '../mui/TextField';

export interface DateTimePickerProps
    extends Pick<DSTextFieldProps, 'className' | 'error' | 'fullWidth' | 'helperText' | 'label' | 'onBlur' | 'style'> {
    value?: string;
    onChange?: (newValue: string) => void;
    type?: 'date' | 'datetime-local' | 'time';
}

export const DateTimePicker = (props: DateTimePickerProps): JSX.Element => {
    const { onChange, type = 'datetime-local', value } = props;
    const format = React.useMemo(() => {
        switch (type) {
            case 'date':
                return 'YYYY-MM-DD';
            case 'time':
                return 'HH:mm:ss';
            case 'datetime-local':
                return 'YYYY-MM-DDTHH:mm:ss';
            default:
                throw assertNever(type);
        }
    }, [type]);

    const handleChange = React.useCallback(
        (event: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>) => {
            onChange?.(event.target.value);
        },
        [onChange],
    );

    return (
        <DSTextField
            {...props}
            InputLabelProps={{
                shrink: true,
            }}
            type={type}
            value={value === undefined ? '' : moment(value).format(format)}
            onChange={handleChange}
        />
    );
};
DateTimePicker.displayName = 'DateTimePicker';
